import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpRequest } from '@angular/common/http';
import * as ArticleModels from '../../models/articles/articles';
import { EnvironmentService } from '../../../app/services/environment.service';


@Injectable({
  providedIn: 'root'
})
export class ArticleService {


constructor(private httpClient: HttpClient,
            private environment: EnvironmentService) { }

public getDictionary() {
  return this.httpClient.get<ArticleModels.ArticlesDictionaryListModel>(`${this.environment.getApiURL()}/article/dictionary`);
}

}
